<template>
  <div>

    <c-title>Account bestätigen</c-title>

    <p>Dieser Link ist leider nicht mehr gültig. Bitte geben Sie Ihre E-Mail-Adresse ein und fordern einen neuen Bestätigungslink an.</p>
    <c-resend-verification />

  </div>
</template>

<script>
import CTitle from '@/components/CTitle'
import CButton from '@/components/CButton'
import CResendVerification from '@/components/CResendVerification'

import handleRequestError from '@/functions/handleRequestError'

export default {
  name: 'VVerify',

  components: {
    CTitle,
    CButton,
    CResendVerification
  },

  props: {
    identifier: {
      type: String,
      required: true
    }
  },

  created () {
    this.$api.post('auth/verify/', { identifier: this.identifier })
      .then(response => {
        this.$store.commit('notifications/add', {
          type: 'success',
          text: 'Ihr Account wurde erfolgreich verifiziert. Bitte melden Sie sich mit Ihren Daten an.'
        })
        this.$router.push({ name: 'login' })
      })
      .catch(error => {
        if (error.response.data.code === 'token_already_used') {
          this.$router.push({ name: 'login' })
        }

        handleRequestError({
          error,
          fallback: 'Ihr Bestätigungslink konnte leider nicht verifiziert werden. Bitte versuchen Sie es später erneut.'
        })
      })
  }
}
</script>
